(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperLevelHolderDeleteController',SkipperLevelHolderDeleteController);

    SkipperLevelHolderDeleteController.$inject = ['$uibModalInstance', 'entity', 'SkipperLevelHolder'];

    function SkipperLevelHolderDeleteController($uibModalInstance, entity, SkipperLevelHolder) {
        var vm = this;

        vm.skipperLevelHolder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SkipperLevelHolder.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
